import { useEffect, useState } from "react";
import { IState, ReduxMap } from "../../redux/redux";
import { ISchoolAffiliateList } from "./schoolTypes";
import { Server, ServerResponse } from "../../utils/Server";
import StoreX, { store } from "../../redux/oldStore";
import { toast } from "react-toastify";
import Button from "../_Core/Button";


interface IProps extends IState {
    
}


const SchoolAffiliationList = (props:IProps) => {
    const [data, setData] = useState<ISchoolAffiliateList>();
    

    useEffect(() => {
        init();
    },[]);

    const init = () => {
        store.server.getApi<ServerResponse<ISchoolAffiliateList>>("../SchoolAffiliate/List")
        .then(x=>{
            if(x.Success){
                setData(x.Value);
            } else {
                console.log("Error",x.Message);
                toast.error(x.Message);
            }
        });
    };

    const generateParticipationInvoices = ()=>{
        if(!window.confirm("Are you sure you want to generate participation invoices?")) return;

        store.server.getApi<ServerResponse<any>>("../SchoolAffiliate/CreateParticipationInvoices")
        .then(x=>{
            if(x.Success){
                toast.success("Invoices generated successfully");
                init();
            } else {
                console.log("Error",x.Message);
                toast.error(x.Message);
            }
        });
    };

    return (<>
        <div className="flex-between">
            <h2>School Affiliations</h2>            
            <div>
                <Button onClick={init} type="refresh" iconOnly={true} />
                <Button onClick={generateParticipationInvoices} type="open" text="Generate Participation Invoices" />
            </div>
        </div>

        { data && <div className="school-affiliation-list item-list">
            {data.affiliates.map((x,i) => {
                const school = data.schoolsDic[x.SchoolId+''];
                return <div key={i} className="item">
                    <strong>{school ?? 'Unknown school'}</strong>
                    <div>{data.invoices?.filter(f=>f.affiliateId === x.Id)?.map((r,ri)=>{
                        return <div key={ri}>$ {r.invoiceTotal.toFixed(2)} <a href={StoreX.BuildUrlWithFair(`../purchase/getinvoice/${r.invoiceId}`)} target="_blank"> Invoice</a> Memo: {r.memo}</div>
                    })}</div>
                </div>
            })}
        </div>}
    </>);
};

export default ReduxMap(SchoolAffiliationList);